/**
 * Validates email format
 * @param email - Email string to validate
 * @returns true if email is valid, false otherwise
 */
export const validateEmail = (email: string): boolean => {
  if (!email || typeof email !== "string") {
    return false;
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
};

/**
 * Validates password minimum length
 * @param password - Password string to validate
 * @param minLength - Minimum length required (default: 6)
 * @returns true if password meets minimum length, false otherwise
 */
export const validatePassword = (
  password: string,
  minLength: number = 6,
): boolean => {
  if (!password || typeof password !== "string") {
    return false;
  }
  return password.length >= minLength;
};

/**
 * Validates that a street value contains a street name followed by a house number.
 * Requires a name starting with a letter, then whitespace, then a house number
 * (e.g. "Hauptstraße 123", "Am Markt 3", "Main Street 42a").
 */
export const validateStreetWithHouseNumber = (street: string): boolean => {
  if (!street || typeof street !== "string") {
    return false;
  }
  const s = street.trim();
  if (!s) return false;

  return /^[\p{L}][\p{L}\p{M}\s.'-]*\s+\d[\da-zA-Z/-]*$/u.test(s);
};
